import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { themeVariables } from '../theme';

interface MintBurnWrapperProps extends BoxProps {
  background?: string;
}

function MintBurnWrapper({
  children,
  background = themeVariables.background.modal,
  width = '530px',
  color = themeVariables.offWhite.offWhite400,
}: MintBurnWrapperProps) {
  return (
    <Box
      minWidth="530px"
      background={background}
      transition={'0.25s'}
      borderRadius={'1.25rem'}
      border={`1px solid ${themeVariables.cards.stroke}`}
      sx={{ backdropFilter: 'blur(60px)' }}
      width={width}
      padding="1rem"
      height="fit-content"
      color={color}
    >
      {children}
    </Box>
  );
}

export default MintBurnWrapper;
